// log-type-icon.component.ts
import { Component, Input } from "@angular/core";

@Component({
    selector: "log-type-icon",
    templateUrl: "./log-type-icon.component.html",
    styleUrls: ["./log-type-icon.component.scss"],
    standalone: false
})
export class LogTypeIconComponent {
  // Input properties for type and showLabel
  @Input() type: string = "log";
  @Input() showLabel: boolean = false;

  constructor() {}

  // Returns icon, text color, background color, and tooltip based on the type
  getIcon(): {
    icon: string;
    textColor: string;
    bgColor: string;
    tooltip: string;
  } {
    const iconMap: {
      [key: string]: {
        icon: string;
        textColor: string;
        bgColor: string;
        tooltip: string;
      };
    } = {
      log: {
        icon: "mat:info",
        textColor: "text-gray-500",
        bgColor: "bg-gray-100",
        tooltip: "Log",
      },
      error: {
        icon: "mat:error",
        textColor: "text-red-500",
        bgColor: "bg-red-100",
        tooltip: "Chyba",
      },
      warning: {
        icon: "mat:warning",
        textColor: "text-yellow-500",
        bgColor: "bg-yellow-100",
        tooltip: "Varování",
      },
      info: {
        icon: "mat:info",
        textColor: "text-blue-500",
        bgColor: "bg-blue-100",
        tooltip: "Info",
      },
      debug: {
        icon: "mat:bug_report",
        textColor: "text-gray-500",
        bgColor: "bg-gray-100",
        tooltip: "Debug",
      },
      default: {
        icon: "mat:info",
        textColor: "text-gray-500",
        bgColor: "bg-gray-100",
        tooltip: "",
      },
    };

    return iconMap[this.type] || iconMap.default;
  }


}
